import React from 'react'
import { CARD } from './ChatStatsSection'

const bar = (width, height = 14, extra = {}) => ({ width, height, borderRadius: 6, background: '#ecebf8', ...extra })

function ChatStatsSkeleton() {
    return (
        <div>
            <div style={{ display: 'flex', gap: 16, marginBottom: 18, flexWrap: 'wrap' }}>
                {[0, 1, 2].map((i) => (
                    <div key={i} style={{ ...CARD, flex: 1, minWidth: 220 }}>
                        <div className="animate-pulse" style={bar('60%', 12)} />
                        <div className="animate-pulse" style={bar('45%', 28, { marginTop: 10 })} />
                        <div className="animate-pulse" style={bar('80%', 8, { marginTop: 14, borderRadius: 999 })} />
                    </div>
                ))}
            </div>

            <div style={{ ...CARD, padding: '22px 24px', marginBottom: 26 }}>
                <div className="animate-pulse" style={bar(140, 14, { marginBottom: 18 })} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 34, flexWrap: 'wrap' }}>
                    <div className="animate-pulse" style={{ width: 140, height: 140, borderRadius: '50%', background: '#ecebf8' }} />
                    <div style={{ flex: 'none', width: 220, display: 'flex', flexDirection: 'column', gap: 14 }}>
                        {[0, 1, 2].map((i) => (
                            <div key={i} className="animate-pulse" style={bar('100%', 14)} />
                        ))}
                    </div>
                    <div style={{ flex: 1, minWidth: 260, display: 'flex', flexDirection: 'column', gap: 12 }}>
                        <div className="animate-pulse" style={bar('90%', 14)} />
                        <div className="animate-pulse" style={bar('75%', 14)} />
                    </div>
                </div>
            </div>

            <div className="animate-pulse" style={bar(160, 12, { marginBottom: 14 })} />
            <div style={{ display: 'flex', gap: 18, flexWrap: 'wrap' }}>
                {[0, 1].map((i) => (
                    <div key={i} style={{ ...CARD, flex: 1, minWidth: 300, display: 'flex', flexDirection: 'column', gap: 12 }}>
                        {[0, 1, 2].map((j) => (
                            <div key={j} className="animate-pulse" style={bar('100%', 16)} />
                        ))}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ChatStatsSkeleton
